import { ButtonBase, Stack } from "@mui/material";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import type { MyCompetitionsPageProps } from "../types";

export function MyCompetitionsPage({
  tournamentEntries,
  leagueEntries,
}: MyCompetitionsPageProps) {
  const [params] = useSearchParams();
  const type = params.get("type") === "league" ? "league" : "tournament";
  const destination = (value: string) => {
    const next = new URLSearchParams(params);
    next.set("type", value);
    return `/compete/mine?${next}`;
  };
  return (
    <Stack spacing={2}>
      <Stack
        component="nav"
        aria-label="My competition sources"
        direction="row"
        spacing={0.75}
      >
        {(
          [
            ["tournament", "Tournaments"],
            ["league", "Leagues"],
          ] as const
        ).map(([value, label]) => {
          const current = type === value;
          return (
            <ButtonBase
              key={value}
              component={RouterLink}
              to={destination(value)}
              aria-current={current ? "page" : undefined}
              sx={{
                minHeight: 32,
                px: 1.5,
                borderRadius: "999px",
                border: 1,
                borderColor: current ? "primary.main" : "divider",
                bgcolor: current ? "primary.main" : "transparent",
                color: current ? "primary.contrastText" : "text.primary",
                fontSize: "0.8125rem",
                fontWeight: current ? 700 : 500,
                "&.Mui-focusVisible": {
                  outline: 2,
                  outlineColor: "primary.main",
                  outlineOffset: 2,
                },
              }}
            >
              {label}
            </ButtonBase>
          );
        })}
      </Stack>
      {type === "league" ? leagueEntries : tournamentEntries}
    </Stack>
  );
}
